import { render } from "./ProjectPortfolioTracker.vue?vue&type=template&id=c3d42fc6&scoped=true"
import script from "./ProjectPortfolioTracker.vue?vue&type=script&lang=js"
export * from "./ProjectPortfolioTracker.vue?vue&type=script&lang=js"

import "./ProjectPortfolioTracker.vue?vue&type=style&index=0&id=c3d42fc6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d42fc6"]])

export default __exports__